var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCircleUpIcon = function SvgArrowCircleUpIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      fill: "none"
    },
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 3c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9m0 16.8c-4.3 0-7.8-3.5-7.8-7.8S7.7 4.2 12 4.2s7.8 3.5 7.8 7.8-3.5 7.8-7.8 7.8m3.42-8.82c.24.24.24.62 0 .84q-.18.18-.42.18t-.42-.18L12.6 9.84v5.76c0 .34-.26.6-.6.6a.59.59 0 0 1-.6-.6V9.84l-1.98 1.98a.58.58 0 0 1-.84 0c-.22-.24-.24-.62 0-.84l3-3a.58.58 0 0 1 .84 0z"
  })));
};
export default SvgArrowCircleUpIcon;